import { createContext, useContext, useState } from 'react';

export const BGN_PER_EUR = 1.95583;

const CurrencyContext = createContext();

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState('EUR');

  const toggleCurrency = () => setCurrency(c => c === 'EUR' ? 'BGN' : 'EUR');

  const formatPrice = (priceInEur) => {
    const val = parseFloat(priceInEur) || 0;
    if (currency === 'EUR') return `${val.toFixed(2)} €`;
    return `${(val * BGN_PER_EUR).toFixed(2)} лв`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, toggleCurrency, formatPrice }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
